export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}budget/budget/:id`;
    return $resource(url, null, {
        update: {
            method: 'PUT',
            url
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/Budget/index.js